import { FC, lazy, Suspense, useState } from 'react'
import { Button, Modal, Space, Spin, Typography } from 'antd'
import { JobDestination } from '../../domain/job-destination'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const { Title, Text } = Typography

const JobAddresForm = lazy(() => import('./job-address-form.component'))

interface JobAddressEditModalProps {
  jobUUID: string
  destination: JobDestination
  onClose: (isEdited: boolean) => void
}

const JobAddressEditModal: FC<JobAddressEditModalProps> = ({ destination, jobUUID, onClose }) => {
  const { t } = useTranslation()
  const [showSuccess, setShowSuccess] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showForm, setShowForm] = useState(true)

  const handleClose = (isEdited = false) => {
    setShowForm(false)
    setShowSuccess(false)
    setErrorMessage('')
    onClose(isEdited)
  }

  const handleSuccess = () => {
    setShowForm(false)
    setShowSuccess(true)
  }

  const handleError = (errorMessage: string) => {
    setShowForm(false)
    setErrorMessage(errorMessage)
  }

  return (
    <>
      <Modal onCancel={() => handleClose()} visible={showForm} title={t('edit-address')} footer={null}>
        <Suspense fallback={<Spin />}>
          <JobAddresForm onSuccess={handleSuccess} onError={handleError} destination={destination} jobUUID={jobUUID} />
        </Suspense>
      </Modal>

      <Modal
        centered
        title={
          <Space style={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircleOutlined style={{ color: '#52C41A' }} />
            <Title style={{ marginBottom: 0 }} level={5}>
              {t('address-success-modified')}
            </Title>
          </Space>
        }
        onCancel={() => handleClose(true)}
        visible={showSuccess}
        footer={
          <Button type='primary' onClick={() => handleClose(true)}>
            {t('ok')}
          </Button>
        }
      >
        <Text>{t('the-order-will-be-deliver-to-the-new-address')}</Text>
      </Modal>

      <Modal
        centered
        title={
          <Space style={{ display: 'flex', alignItems: 'center' }}>
            <CloseCircleOutlined style={{ color: '#F5222D' }} />
            <Title style={{ marginBottom: 0 }} level={5}>
              {t('address-error-occurred')}
            </Title>
          </Space>
        }
        onCancel={() => handleClose()}
        visible={!!errorMessage}
        footer={
          <Button type='primary' onClick={() => handleClose()}>
            {t('ok')}
          </Button>
        }
      >
        <Text>{errorMessage}</Text>
      </Modal>
    </>
  )
}

export default JobAddressEditModal
